import styled from 'styled-components';

/** Cell content that is not plain text (chips, buttons); the text case goes through Table.RowItem. */
export const CellContent = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  padding: 0 17px;
`;
